import renderPlan from './plan';

export const edit = ctx => {
  // Render React app
  renderPlan(ctx.params.id);
};



// WEBPACK FOOTER //
// ./src/modules/saas/aast/zones/index.js